import { render, staticRenderFns } from "./OtherCustomActions.vue?vue&type=template&id=455f1ccc&scoped=true&"
import script from "./OtherCustomActions.vue?vue&type=script&lang=js&"
export * from "./OtherCustomActions.vue?vue&type=script&lang=js&"
import style0 from "./OtherCustomActions.vue?vue&type=style&index=0&id=455f1ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455f1ccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('455f1ccc')) {
      api.createRecord('455f1ccc', component.options)
    } else {
      api.reload('455f1ccc', component.options)
    }
    module.hot.accept("./OtherCustomActions.vue?vue&type=template&id=455f1ccc&scoped=true&", function () {
      api.rerender('455f1ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/CustomActions/OtherCustomActions.vue"
export default component.exports